import T from '../../../../common/components/T';

export const skeleton = () => {
    return [
        {
            row: [5, 45, 40, 10],
            items: [
                {
                    type: 'circle'
                },
                {
                    content: [
                        {
                            type: 'subtitle',
                            width: 60
                        },
                        {
                            type: 'text'
                        }
                    ]
                },
                'empty',
                {
                    type: 'blockSM',
                    vertical: 'unset'
                }
            ],
            vertical: 'unset',
            gap: 2
        }
        // 'line',
        // {
        //     row: [5, 45, 40, 10],
        //     items: [
        //         {
        //             type: 'circle'
        //         },
        //         {
        //             content: [
        //                 {
        //                     type: 'subtitle',
        //                     width: 60
        //                 },
        //                 {
        //                     type: 'text'
        //                 }
        //             ]
        //         },
        //         'empty',
        //         {
        //             type: 'blockSM',
        //             vertical: 'unset'
        //         }
        //     ],
        //     vertical: 'unset',
        //     gap: 2
        // },
        // 'line',
        // {
        //     row: [5, 45, 40, 10],
        //     items: [
        //         {
        //             type: 'circle'
        //         },
        //         {
        //             content: [
        //                 {
        //                     type: 'subtitle',
        //                     width: 60
        //                 },
        //                 {
        //                     type: 'text'
        //                 }
        //             ]
        //         },
        //         'empty',
        //         {
        //             type: 'blockSM',
        //             vertical: 'unset'
        //         }
        //     ],
        //     vertical: 'unset',
        //     gap: 2
        // }
    ];
};

export const getProlongationInfo = (prolongation, activity) => {
    let title = '';
    let description = '';
    const need_prolong = prolongation?.need_prolong;
    switch (true) {
        case need_prolong && activity?.data?.activity: {
            title = (
                <T
                    vars={{
                        prolong: Math.round(Number(activity?.data?.conditions?.prolong?.personal_volume?.target))
                    }}
                    textName='prolongation-info-description-2-v1'
                    defaultStr='Необходима пролонгация. Для пролонгации произведите покупку на ${prolong} PV или более.'
                    page='/office'
                />
            );
            break;
        }
        case need_prolong && !activity?.data?.activity: {
            title = (
                <T
                    textName='prolongation-info-description-3'
                    vars={{
                        activity: Math.round(Number(activity?.data?.conditions?.activity?.personal_volume?.target)),
                        prolong: Math.round(Number(activity?.data?.conditions?.prolong?.personal_volume?.target))
                    }}
                    defaultStr='Ваш аккаунт нуждается в пролонгации и активации. Для этого необходимо произвести покупку на ${prolong}  PV для пролонгации и ${activity} PV для активации.'
                    page='/office'
                />
            );
            break;
        }
        case !need_prolong && !activity?.data?.activity: {
            title = (
                <T
                    textName='to-access-to-office-alert-1'
                    defaultStr='Для доступа в личный кабинет необходимо активировать учетную запись.'
                    page='/office'
                />
            );
            break;
        }
        default:
            break;
    }

    return {
        title,
        description
    };
};
